var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "button-container",
      style: {
        "justify-content":
          _vm.actionType !== "view" ? "space-between" : "flex-end"
      }
    },
    [
      _vm.actionType !== "view"
        ? _c("management-button", {
            attrs: {
              label: _vm.$t("Delete" + _vm.objectType),
              type: "cancel",
              align: "left"
            },
            on: {
              buttonClick: function($event) {
                return _vm.$emit("delete-item")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-855b7334", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-855b7334","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/PlanningDetailsTableButtons.vue
// module id = null
// module chunks = 